import { useTranslation } from 'react-i18next';

import Chip from '@/components/Chip';
import { PAYMENT_STATUS, PAYMENT_TYPE } from '@/models/payment';
import { cn } from '@/utils';

// Payment statuses
const statuses = {
	// Generic states
	[PAYMENT_STATUS.PAID]: {
		textKey: 'paid',
		color: 'success',
		textColor: 'text-green'
	},
	[PAYMENT_STATUS.ERROR]: {
		textKey: 'error',
		color: 'error',
		textColor: 'text-red'
	},
	[PAYMENT_STATUS.PENDING]: {
		textKey: 'pending',
		color: 'warning',
		textColor: 'text-orange'
	},
	[PAYMENT_STATUS.CANCELED]: {
		textKey: 'canceled',
		color: 'default',
		textColor: 'text-grey-400'
	},
	retry: {
		textKey: 'retry',
		color: 'error',
		textColor: 'text-red'
	}
};

function PaymentStatusChip({ status, type, hasPayAction }) {
	const { t } = useTranslation();

	let parsedStatus = statuses[status];

	if (type !== PAYMENT_TYPE.PAYMENT) {
		parsedStatus = statuses[type];
	}

	if (
		hasPayAction &&
		type === PAYMENT_TYPE.PAYMENT &&
		status === PAYMENT_STATUS.ERROR
	) {
		parsedStatus = statuses.retry;
	}

	// fallback chip for not listed statuses
	if (!parsedStatus) {
		parsedStatus = {
			textKey: status,
			color: 'default',
			textColor: 'text-grey-400'
		};
	}

	return (
		<Chip bgColor={parsedStatus.color}>
			<p
				className={cn(
					'text-xs font-semibold capitalize leading-5',
					parsedStatus.textColor
				)}
			>
				{t(`billing.payment.statuses.${parsedStatus.textKey}`)}
			</p>
		</Chip>
	);
}

export default PaymentStatusChip;
